<template>
  <v-container fluid class="py-10 px-md-16">
    <v-row dense justify="center">
      <!-- Anatomía del botón -->
      <v-col cols="12" md="7">
        <v-card class="pa-6" rounded="lg" elevation="1">
          <h3 class="font-weight-bold mb-6">Anatomía del Botón</h3>

          <!-- Botón con borde punteado y espacio -->
          <div
            class="d-flex align-center"
            style="border: 2px dashed #D1D5DB; border-radius: 24px; padding: 8px; width: 100%;"
          >
            <v-btn
              class="text-none text-white"
              style="background: linear-gradient(to right, #6366F1, #8B5CF6); border-radius: 12px; padding: 12px 32px; font-weight: 600; font-size: 16px; text-transform: none;"
              elevation="0"
            >
              <v-icon left size="20">mdi-plus</v-icon>
              Crear Proyecto
            </v-btn>
          </div>

          <!-- Elementos -->
          <ul class="mt-6" style="font-size: 14px; line-height: 24px;">
            <li><strong>•</strong> Icono (opcional) – 20px</li>
            <li><strong>•</strong> Texto – Axiforma SemiBold 16px</li>
            <li><strong>•</strong> Container – 12px border-radius</li>
            <li><strong>•</strong> Padding – 12px vertical, 32px horizontal</li>
          </ul>
        </v-card>
      </v-col>

      <!-- Estados Interactivos -->
      <v-col cols="12" md="5">
        <v-card class="pa-6" rounded="lg" elevation="1">
          <h3 class="font-weight-bold mb-6">Estados Interactivos</h3>

          <v-btn block class="mb-2 text-white" elevation="0"
            style="background: linear-gradient(to right, #6366F1, #8B5CF6); border-radius: 8px; text-transform: none; font-weight: 500;">
            Default
          </v-btn>

          <v-btn block class="mb-2 text-white" elevation="0"
            style="background: linear-gradient(to right, #6D5DF6, #7A3CF6); border-radius: 8px; text-transform: none; font-weight: 500;">
            Hover
          </v-btn>

          <v-btn block class="mb-2 text-white" elevation="0"
            style="background: linear-gradient(to right, #4B2999, #6B21A8); border-radius: 8px; text-transform: none; font-weight: 500;">
            Active
          </v-btn>

          <v-btn block class="mb-2" disabled color="#E5E7EB"
            style="border-radius: 8px; text-transform: none; color: #9CA3AF;">
            Disabled
          </v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
export default {
  name: 'Fonts'
}
</script>

<style scoped>
.poppinsFont {
  font-family: 'Poppins', sans-serif;
}
</style>
